const ClientConfig = {
	 siteUrl: 'https://event-calendar-with-cloud-sql.el.r.appspot.com',
	// siteUrl :'http://localhost:50001',
};

export default ClientConfig;